
























































import { Vue, Component } from 'vue-property-decorator';
import AppDrawer from '@/components/AppDrawer.vue';
import AppToolBar from '@/components/AppToolBar.vue';
import { AppStore } from '@/store/modules/app';
import { UserStore } from './store/modules/user';

@Component({
  components: {
    AppDrawer,
    AppToolBar
  }
})
export default class App extends Vue {
  expanded: boolean = true;
  get snackBarConfig() {
    return AppStore.config;
  }
  get globalMask() {
    return AppStore.globalMask;
  }

  created() {}
}
